import React, { useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import { useUserContext } from '../contexts'
import * as ga from '../lib/ga'
import { useNavigate } from 'react-router-dom'

import { XCircleIcon } from '@heroicons/react/solid'

const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($oldPassword: String!, $newPassword: String!) {
    appUpdatePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`

function UpdatePasswordPage() {
  const navigate = useNavigate()
  const { updateUser } = useUserContext()
  const [errorName, setErrorName] = useState(null)

  const tempStorage = window.sessionStorage

  let formNewPassword

  const [appUpdatePassword, { loading: updatePasswordLoading }] = useMutation(
    UPDATE_PASSWORD,
    {
      onCompleted() {
        tempStorage.removeItem('pass')

        updateUser({
          isFirstLogin: false
        })

        navigate('/accept')
      }
    }
  )

  // TODO: Show Accept overlay
  // When clicked accept, mutation to db
  // Redirect on ok aswer from mutation
  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Skapa ett personligt lösenord
            </h2>
          </div>
          <form
            className="mt-8 space-y-6"
            onSubmit={(e) => {
              e.preventDefault()

              const variables = {
                oldPassword: tempStorage.getItem('pass'),
                newPassword: formNewPassword.value
              }

              appUpdatePassword({
                variables
              })

              formNewPassword.value = ''

              setErrorName(null)

              ga.event({
                action: 'login_update_password'
              })
            }}
          >
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="formNewPassword" className="sr-only">
                  Ange nytt lösenord
                </label>
                <input
                  id="formNewPassword"
                  name="formNewPassword"
                  type="password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="Ange nytt lösenord"
                  ref={(node) => {
                    formNewPassword = node
                  }}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={updatePasswordLoading ? true : false}
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Spara nytt lösenord
              </button>
            </div>

            {errorName && (
              <div className="rounded-md bg-red-50 border border-red-300 p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">
                      Det var ett fel i formuläret
                    </h3>
                    <div className="mt-2 text-sm text-red-700">
                      <ul role="list" className="list-disc pl-5 space-y-1">
                        <li>{errorName}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>

      {/* <form
        className={stylesForm.form}
        onSubmit={(e) => {
          e.preventDefault();

          const variables = {
            oldPassword: tempStorage.getItem('pass'),
            newPassword: formNewPassword.value,
          };

          // console.log({ variables });

          appUpdatePassword({
            variables,
          });

          // email.value = "";
          // password.value = "";
          formNewPassword.value = '';

          setErrorName(null);

          ga.event({
            action: 'login_update_password',
            // params : {
            //   search_term: query
            // }
          });
        }}
      >
        <div className={stylesForm.inputrow}>
          <label htmlFor="formNewPassword" className={stylesForm.label}>
            Ange nytt lösenord
          </label>
          <input
            id="formNewPassword"
            type="password"
            className={stylesForm.input}
            // placeholder="d1tt-un1ka-losenord!"
            ref={(node) => {
              formNewPassword = node;
            }}
          />
        </div>

        <div className={stylesForm.submitBtnWrap}>
          <button
            type="submit"
            className={`btn btn-primary ${stylesForm.submitBtn}`}
            disabled={updatePasswordLoading ? true : false}
          >
            Spara nytt lösenord
          </button>
        </div>

        {errorName && (
          <div style={{ textAlign: 'center', color: 'red', padding: '10px' }}>
            {errorName}
          </div>
        )}
      </form> */}
    </>
  )
}

export default UpdatePasswordPage
